// extracted by mini-css-extract-plugin
module.exports = {"main":"ContentLayout_main__3Xku-","children":"ContentLayout_children__q6lkt"};